<template>
  <button class="async-button" :type="$props.type" @click="click" :disabled="$props.disabled || $props.executing">
    <template v-if="!$props.executing">
      <span>
        <slot/>
        <slot name="buttonContent"/> <!-- support backwards compatibility for now, todo refactor to remove named slot -->
      </span>
    </template>
    <span v-else>
      <font-awesome-icon icon="spinner" pulse aria-label="Loading..."/>
    </span>
  </button>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    components: {
      FontAwesomeIcon
    },
    methods: {
      click(e) {
        this.$emit('clicked', e)
      }
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      executing: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'button',
        validator: function(value) {
          return ['reset', 'submit', 'button'].indexOf(value) !== -1
        }
      },
      classNames: {
        type: String
      }
    }
  }
</script>
